import React from "react";

interface WinnerModalProps {
  isShowing: boolean;
}

const WinnerModal = ({ isShowing }: WinnerModalProps) => {
  if (!isShowing) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full mx-4">
        <div className="border-b px-6 py-4">
          <h2 className="text-xl font-semibold">You Win!</h2>
        </div>
        <div className="px-6 py-4">Nice job! Look forward to seeing you for tomorrow's puzzle!</div>
        <div className="border-t px-6 py-4">{/*TODO:Add ok button */}</div>
      </div>
    </div>
  );
};

export default WinnerModal;
